import React from 'react';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: 'none',
        borderRadius: '10px',
        padding: '32px',
        fontFamily: 'Prompt',
        maxHeight: '80%',
        width: '80vw',
        maxWidth: '1100px',
        minWidth: '300px',
        overflowY: 'scroll',
        zIndex: 9
    },
    overlay: {
        background: 'rgba(0,0,0,0.5)'
    }
};

const ConfirmDialogModal = ({ isOpen, onConfirm, onClose, message, text = 'Confirm the transaction', children = null}) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={customStyles}>
                 <div className="flex-v">
                        <div className="is-size-5 text-center has-text-grey-dark mb-24">{message}</div>
                        <div className="is-size-6 has-text-grey mb-16">{text}</div>
                        {children}
                        <div className="flex-h flex-between">
                            <button onClick={() => onConfirm()} className={`button is-success is-fullwidth is-rounded mt-16 mb-16 mr-16`}>Confirm</button>
                            <button onClick={() => onClose()} className={`button is-danger is-fullwidth is-rounded mt-16 mb-16 ml-16`}>Cancel</button>
                        </div>
                    </div>
        </Modal>
    );
}

export default ConfirmDialogModal;
